// extracted by mini-css-extract-plugin
module.exports = {"blog":"Blog_blog__3OxqA"};